import { forwardRef } from 'react';
import { StyledInputGroup } from './styled';

const InputGroup = forwardRef((props, ref) => (
  <StyledInputGroup ref={ref} {...props} />
));

export default InputGroup;
